import { init } from '@emailjs/browser';

// Initialize EmailJS with public key
const emailPublicKey = process.env.REACT_APP_EMAIL_PUBLIC_KEY || process.env.EMAIL_PUBLIC_KEY;

if (emailPublicKey) {
  init(emailPublicKey);
  console.log("EmailJS initialized");
} else {
  console.warn("EmailJS public key missing - emails may not work properly");
}

export default {
  serviceId: "service_4z218de",
  templateId: "template_1gc3heb",
  publicKey: "8jAv2xPjMlzbVElUz"
}; 